import React from 'react'
import PropTypes from 'prop-types'

import CountdownBanner from 'components/headerBanners/CountdownBanner/CountdownBanner'

import messages from './messages'


const DiscountCountdownBanner = (props) => {
  const { discount, horizontal, uppercase, withPchTitle, withDailyBeastTitle, withChristmasBackground } = props

  let title = messages.title

  if (withPchTitle) {
    title = messages.pchTitle
  }
  else if (withDailyBeastTitle) {
    title = messages.dailyBeastTitle
  }

  return (
    <CountdownBanner
      uppercase={uppercase}
      horizontal={horizontal}
      withChristmasBackground={withChristmasBackground}
      message={{
        ...title,
        values: { discount },
      }}
    />
  )
}

DiscountCountdownBanner.propTypes = {
  discount: PropTypes.number,
  withPchTitle: PropTypes.bool,
  withDailyBeastTitle: PropTypes.bool,
}

DiscountCountdownBanner.defaultProps = {
  discount: 25,
  uppercase: true,
  withPchTitle: false,
  withDailyBeastTitle: false,
}


export default DiscountCountdownBanner
